import request from '@/utils/request'

/**
 * 根据文件类型数据
 * @param data
 * @returns {AxiosPromise}
 */
export function getFileKinds(data) {
  return request({
    url: 'api/getFileKinds',
    method: 'get',
    params: data
  })
}

/**
 * 获取文件夹树
 * @param data
 * @returns {AxiosPromise}
 */
export function getFolders(data) {
  return request({
    url: 'api/getFolders',
    method: 'get',
    params: data
  })
}

/**
 * 创建文件夹
 * @param data
 * @returns {AxiosPromise}
 */
export function createFolder(data) {
  return request({
    url: 'api/createFolder',
    method: 'post',
    data: data
  })
}

/**
 * 编辑文件夹
 * @param data
 * @returns {AxiosPromise}
 */
export function editFolder(data) {
  return request({
    url: 'api/editFolder',
    method: 'post',
    data: data
  })
}

/**
 * 删除文件夹/文件
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteFolderOrFile(data) {
  return request({
    url: 'api/deleteFolderOrFile',
    method: 'post',
    data: data
  })
}

/**
 * 获取文件
 * @param data
 * @returns {AxiosPromise}
 */
export function getFiles(data) {
  return request({
    url: 'api/getFiles',
    method: 'get',
    params: data
  })
}

/**
 * 获取文件夹或文件历史记录列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getFolderOrFileHistory(data) {
  return request({
    url: 'api/getFolderOrFileHistory',
    method: 'get',
    params: data
  })
}

/**
 * 上传文件
 * @param data
 * @returns {AxiosPromise}
 */
export function uploadFile(data) {
  return request({
    url: 'api/uploadFile',
    method: 'post',
    data: data
  })
}

/**
 * 批量上传文件
 * @param data
 * @returns {AxiosPromise}
 */
export function uploadFiles(data) {
  return request({
    url: 'api/uploadFiles',
    method: 'post',
    data: data
  })
}

/**
 * 编辑文件
 * @param data
 * @returns {AxiosPromise}
 */
export function editFile(data) {
  return request({
    url: 'api/editFile',
    method: 'post',
    data: data
  })
}

/**
 * 移动文件/文件夹
 * @param data
 * @returns {AxiosPromise}
 */
export function moveFolderOrFile(data) {
  return request({
    url: 'api/moveFolderOrFile',
    method: 'post',
    data: data
  })
}

/**
 * 转让文件/文件夹 仅管理员
 * @param data
 * @returns {AxiosPromise}
 */
export function moveFolderOrFileRight(data) {
  return request({
    url: 'api/moveFolderOrFileRight',
    method: 'post',
    data: data
  })
}

/**
 * 修改文件/文件夹名称
 * @param data
 * @returns {AxiosPromise}
 */
export function editFolderOrFileName(data) {
  return request({
    url: 'api/editFolderOrFileName',
    method: 'post',
    data: data
  })
}

/**
 * 修改文件/文件夹权限
 * @param data
 * @returns {AxiosPromise}
 */
export function editFolderOrFileRight(data) {
  return request({
    url: 'api/editFolderOrFileRight',
    method: 'post',
    data: data
  })
}


/**
 * 获取文件消息通知
 * @param data
 * @returns {AxiosPromise}
 */
export function getFileNotice(data) {
  return request({
    url: 'api/getFileNotice',
    method: 'get',
    params: data
  })
}

/**
 * 获取文件消息通知详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getFileNoticeDetail(data) {
  return request({
    url: 'api/getFileNoticeDetail',
    method: 'get',
    params: data
  })
}


/**
 * 审核文件
 * @param data
 * @returns {AxiosPromise}
 */
export function approveFile(data) {
  return request({
    url: 'api/approveFile',
    method: 'post',
    data: data
  })
}

/**
 * 记录阅读文件
 * @param data
 * @returns {AxiosPromise}
 */
export function readFile(data) {
  return request({
    url: 'api/readFile',
    method: 'post',
    data: data
  })
}

/**
 * 查询阅读文件历史
 * @param data
 * @returns {AxiosPromise}
 */
export function readFileHistory(data) {
  return request({
    url: 'api/readFileHistory',
    method: 'post',
    data: data
  })
}

/**
 * 获取 oss config
 * @param data
 * @returns {AxiosPromise}
 */
export function getOssConfig() {
  return request({
    url: 'api/getOssConfig',
    method: 'post'
  })
}
